/**
 * Development-only Logger for Ticket Frontend
 *
 * Provides console logging that is automatically disabled in production.
 * Use this instead of direct console.log/warn/error calls.
 */

const IS_DEV =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname.endsWith('.localhost') ||
   window.location.hostname.endsWith('.test') ||
   window.location.hostname.endsWith('.local'));

/**
 * No-op function for production
 */
const noop = () => {};

/**
 * Logger instance - only logs in development environments
 */
export const logger = {
  log: IS_DEV ? console.log.bind(console, '[tickets]') : noop,
  warn: IS_DEV ? console.warn.bind(console, '[tickets]') : noop,
  error: IS_DEV ? console.error.bind(console, '[tickets]') : noop,
  debug: IS_DEV ? console.debug.bind(console, '[tickets]') : noop,
  info: IS_DEV ? console.info.bind(console, '[tickets]') : noop,
};

export default logger;
